import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useIsMobile from 'src/hooks/useIsMobile';
import classNames from 'classnames';

import { RootState, Dispatch } from 'src/configs/store';
import { getFlag } from 'src/utils/utils';
import Icon from 'src/components/Icon/Icon';

interface RacingDetailProps {
  /**
   * Portrayed event's information.
   */
  event: {
    countryCode: string,
    name: string,
    date: string,
  }
  cardCode?: string,
  couponCode?: number
  /**
   * Background image shown
   */
   icon: string
}

export default function RacingDetail({ event, icon, cardCode = '', couponCode=null }: RacingDetailProps) {
  const history = useHistory();
  const location = useLocation();
  const mobile = useIsMobile();
  const { t } = useTranslation('common');

  const { selectedTab } = useSelector((state: RootState) => state.racing);
  const dispatch = useDispatch<Dispatch>();

  const goBack = () => {
    dispatch.events.setEvent({});
    history.push(`/racing/${ selectedTab }${ location.search }`);
  };

  let racingIconClass = 'detail-header__background';
  if (mobile) {
    if (icon === 'dogs' || icon === 'carriages') {
      racingIconClass = 'detail-header__background--dogs';
    }
  }

  return (
    <>
      <div className={ racingIconClass }>
        <Icon className="racing" icon={ icon } />
      </div>
      <div className="detail-header__header-wrapper">
        <div className="detail-header__back" onClick={ goBack }>
          <Icon icon="arrow" className="detail-header__arrow" />
          { !mobile && <span>{ t('racingDetail.meetings') }</span> }
        </div>

        <div className={
          classNames({
            'detail-header__title-info': true,
            'detail-header__title-info--big-title': event.name?.length > 17
          })
        }
        >
          <span
            className={
              classNames({
                'detail-header__tournament-flag': true,
                'detail-header__tournament-flag--big-title': event.name?.length > 17
              })
            }
            style={ { backgroundImage: `url(${ getFlag(event.countryCode) })` } }
          />
          <span className="detail-header__info-text" title={ event.name }>{ event.name }</span>

          {
            event.date && (
              <span className="detail-header__date">{ event.date }</span>
            )
          }
        </div>
      </div>
      {
        cardCode && <div className="detail-header__coupon">
          { ` ${ t('racingDetail.cardCode') } : ${ cardCode } /  ${ t('racingDetail.couponCode') }: ${ couponCode }` }
        </div>
      }
    </>
  );
}
